// extracted by mini-css-extract-plugin
module.exports = {"transaction_history":"TransactionHistory_transaction_history__1l6Zn","table_head":"TransactionHistory_table_head__3VbY8","table_body":"TransactionHistory_table_body__2eZb9"};